"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookSquare = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function FacebookSquare(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M21.0938 5.69922V19.6992C21.0938 20.8038 20.1983 21.6992 19.0938 21.6992H15.3438C15.0676 21.6992 14.8438 21.4754 14.8438 21.1992V15.1992H17.1838C17.4214 15.1993 17.6262 15.0321 17.6737 14.7992L18.0337 12.9992C18.0486 12.9265 18.0304 12.8509 17.984 12.793C17.9377 12.735 17.868 12.7007 17.7937 12.6992H14.8438V9.44922C14.8438 9.31115 14.9557 9.19922 15.0938 9.19922H17.5938C17.8699 9.19922 18.0938 8.97536 18.0938 8.69922V7.19922C18.0938 6.92308 17.8699 6.69922 17.5938 6.69922H15.0938C13.4369 6.69922 12.0938 8.04236 12.0938 9.69922V12.6992H10.8637C10.5876 12.6992 10.3637 12.9231 10.3637 13.1992V14.6992C10.3637 14.9754 10.5876 15.1992 10.8637 15.1992H12.0938V21.1992C12.0938 21.4754 11.8699 21.6992 11.5938 21.6992H5.09375C3.98918 21.6992 3.09375 20.8038 3.09375 19.6992V5.69922C3.09375 4.59465 3.98918 3.69922 5.09375 3.69922H19.0938C20.1983 3.69922 21.0938 4.59465 21.0938 5.69922Z",
    fill: "currentColor"
  }));
}

exports.FacebookSquare = FacebookSquare;